import styles from "./styles.module.css";
import emptyIcon from "../../../images/svg/empty-report.svg";

export default function EmptyState({
  title = "Sales summary",
  message = "Looks like there are no record to show right now.",
}) {
  return (
    <div className={styles.empty}>
      <img src={emptyIcon} alt="empty" className={styles.image} />
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.message}>{message}</p>
    </div>
  );
}
